import { createVNode as _createVNode } from "vue";
import "core-js/modules/es.array.map.js";
import "core-js/modules/esnext.iterator.map.js";
import { createFormItem } from '@/component-create/utils/create-form-item';
import { createTableActionItem, createTableColumn } from '@/component-create/utils/create-table-column';
import { FORM_ITEM } from '@/components/form/enums';
import { USER_GENDER, USER_STATUS } from '@/constant/system/code';
import { formatter as _formatter } from '@/utils/common';
import { ElTag } from 'element-plus';
import 'element-plus/es/components/tag/style/css'

export var SearchItems = [createFormItem('用户名', 'username', FORM_ITEM.INPUT, {
  clearable: true,
  maxlength: '20',
  onInput: function onInput(e) {
    console.log(e);
  }
}), createFormItem('昵称', 'nickname', FORM_ITEM.INPUT, {
  clearable: true,
  maxlength: '20'
}), createFormItem('手机号码', 'phoneNumber', FORM_ITEM.INPUT, {
  clearable: true,
  maxlength: '11'
}), createFormItem('性别', 'gender', FORM_ITEM.SELECT, {
  loader: 'USER_GENDER',
  allOption: true
}), createFormItem('状态', 'status', FORM_ITEM.SELECT, {
  loader: 'USER_STATUS',
  allOption: true
})];
export function column(editFn, deleteFn) {
  var col = [{
    type: 'selection'
  }, {
    label: '序号',
    type: 'index',
    width: '60'
  }, createTableColumn('用户名', 'username', '120'), createTableColumn('用户昵称', 'nickname', '120'), createTableColumn('手机号码', 'phoneNumber', '120', 'center'), createTableColumn('邮箱', 'email', '200', undefined, {
    showOverflowTooltip: true
  }), createTableColumn('性别', 'gender', '60', 'center', {
    showOverflowTooltip: true,
    formatter: function formatter(row) {
      return _formatter(USER_GENDER, row.gender);
    }
  }), createTableColumn('状态', 'status', '60', 'center', {
    showOverflowTooltip: true,
    formatter: function formatter(row) {
      return _formatter(USER_STATUS, row.status);
    }
  }), createTableColumn('岗位', 'posts', undefined, undefined, {
    showOverflowTooltip: true,
    slot: function slot(row) {
      return h(_createVNode("div", null, [row.posts.map(function (item) {
        return _createVNode(ElTag, {
          "style": {
            marginRight: '5px'
          }
        }, {
          default: function _default() {
            return [item.postName];
          }
        });
      })]));
    }
  }), createTableColumn('备注', 'remark', undefined, undefined, {
    showOverflowTooltip: true
  }), createTableColumn('创建时间', 'createdAt', '150', 'center'), createTableColumn('操作', undefined, '150', 'center', {
    controller: [createTableActionItem('编辑', 'Edit', editFn), createTableActionItem('删除', 'Delete', deleteFn)]
  })];
  return col;
}